webpackJsonp([27],{

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

var BASEURL = exports.BASEURL = "https://api.epixcinemas.com";

// export const ImageS3URL = `https://images.brijimages.com/`;
var IMGBASEURL = exports.IMGBASEURL = "https://images.epixcinemas.com";

var fallbackImgSrc = exports.fallbackImgSrc = BASEURL + "assets/fallback-image.png";
var fallbackImgBannerSrc = exports.fallbackImgBannerSrc = BASEURL + "assets/fallback-image-banner.png";
var EPIX_TOKEN = exports.EPIX_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjU4ZDJlZTM4LTI4MDctNDQ4My05YzVhLThhZDYxMjI2OGY0MSIsImlhdCI6MTcwMzgzNTMzNn0.3eAPpdCzFTsGuHbgeJFCZknPbWS0WjDD1aSnNy_HRTk";
var TOKEN = exports.TOKEN = EPIX_TOKEN;

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(161);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(105);

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__(86);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(106);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import router from '../router';

exports.default = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$cinema_id = params.cinema_id,
      cinema_id = _params$cinema_id === undefined ? null : _params$cinema_id;

  var instance = _axios2.default.create({
    baseURL: _index.BASEURL,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + _index.TOKEN
    }
  });

  var JWT = window.localStorage.getItem("TOKEN") ? window.localStorage.getItem("TOKEN") : _index.TOKEN;
  if (JWT) {
    instance.defaults.headers.common["sales-authorization"] = JWT;
  }
  instance.defaults.headers.common["x-cinema-source"] = "0";

  instance.defaults.headers.common["x-cinema-destination"] = cinema_id ? cinema_id : "0";
  // instance.defaults.headers.common['Authorization'] = Vue.cookie.get('STRHTID')
  // instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
  instance.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
  }, function (error) {
    // Do something with response error
    if (error && error.response && error.response.status == 403) {
      // vmVue.$router.push({
      //   path: "/access-denied"
      // });
      _vue2.default.toasted.show("You are not authorized");
    } else if (error && error.response && error.response.status == 401) {
      localStorage.clear();
      _vue2.default.cookie.delete("BRHSID");
      vmVue.$router.push({
        path: "/" // '/go-to-login'
      });
    } else {
      return _promise2.default.reject(error);
    }
  });
  return instance;
};

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Api = __webpack_require__(253);

var _Api2 = _interopRequireDefault(_Api);

var _ApiHelper = __webpack_require__(603);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  GetGlobalOptions: function GetGlobalOptions(payload) {
    if (payload) {
      var query = (0, _ApiHelper.createQueryString)(payload);
      return (0, _Api2.default)().get("/api/v3/external/sales-analytics/global-options" + query);
    } else {
      return (0, _Api2.default)().get("/api/v3/external/sales-analytics/global-options");
    }
  },
  GetCinemas: function GetCinemas() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    payload.cine_id = payload.cine_id && payload.cine_id.toString().length > 0 ? payload.cine_id : "";
    return (0, _Api2.default)().post("/api/v3/external/sales-analytics/getcinemas", payload);
  }
};

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_loader_vue__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Partials_connection_lost_vue__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Partials_globalModal_vue__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_navLists__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_navLists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__helper_navLists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_MasterService__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_MasterService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__services_MasterService__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App",
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__components_Partials_loader_vue__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_Partials_globalModal_vue__["a" /* default */],
    connectionLost: __WEBPACK_IMPORTED_MODULE_2__components_Partials_connection_lost_vue__["a" /* default */]
  },
  data: function data() {
    return {
      onLine: navigator.onLine,
      showAnalyticsMenu: false
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // return store.fetchSpecial(to.params.slug).then(next)
    next();
  },
  beforeMount: function beforeMount() {},
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
  mounted: function mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.fetchGlobalOptions();
  },

  computed: {
    navBarItems: function navBarItems() {
      return __WEBPACK_IMPORTED_MODULE_4__helper_navLists___default.a;
    },
    currentNavName: function currentNavName() {
      var _this = this;

      var navName = "";
      var navIndex = this.navBarItems.findIndex(function (navObj) {
        return navObj.url == _this.$route.path;
      });
      if (navIndex >= 0) {
        navName = this.navBarItems[navIndex].name;
      } else {
        return;
      }
      return navName;
    }
  },
  methods: {
    homePage: function homePage() {
      this.$router.push("/reports");
    },
    toggleAnalyticsMenu: function toggleAnalyticsMenu() {
      this.showAnalyticsMenu = !this.showAnalyticsMenu;
    },
    navigate: function navigate(path) {
      this.showAnalyticsMenu = false;
      this.$router.push(path);
      this.$root.$emit("bv::hide::sidebar", "sidebar-1");
    },
    updateOnlineStatus: function updateOnlineStatus(e) {
      var type = e.type;

      this.onLine = type === "online";
    },

    fetchGlobalOptions: function fetchGlobalOptions() {
      __WEBPACK_IMPORTED_MODULE_5__services_MasterService___default.a.GetGlobalOptions().then(function (response) {
        var data = response.data;

        console.log("Client_name", data);
        if (data && data.status && data.Records.length > 0) {
          var CLIENT_SETUP_NAME = data.Records.find(function (go) {
            return go.go_key == "CLIENT_SETUP_NAME";
          });
          console.log("CLIENT_SETUP_NAME", CLIENT_SETUP_NAME);
          localStorage.setItem("setUpName", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(CLIENT_SETUP_NAME.go_value));
        } else {
          console.log("Erro in fetching global options");
        }
      });
    }
  }
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ConnectionLost",
  methods: {
    retry: function retry() {
      window.location.reload();
    }
  }
});

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createQueryString = undefined;

var _toConsumableArray2 = __webpack_require__(602);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(262);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQueryString = exports.createQueryString = function createQueryString() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var query = "";
    if ((0, _keys2.default)(payload).length > 0) {
        var urlparams = new URLSearchParams();
        for (var key in payload) {
            if (payload[key]) {
                urlparams.append(key, payload[key]);
            }
        }
        if ([].concat((0, _toConsumableArray3.default)(urlparams.entries())).length > 0) {
            query += "?" + urlparams.toString();
        }
    }
    return query;
};

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Role = exports.Role = {
  SuperAdmin: "Super Admin",
  HoManager: "HO Manager",
  CinemaManager: "Cinema Manager",
  PosOperator: "POS Operator", // PosOperator: 'POS Operator',
  PosFnBOperator: "FnB POS Operator",
  Distributor: "Distributor",
  BoxOfficeFnbOperator: "Box Office Fnb",
  AnalyticsManager: "Analytics Manager",
  KitchenManager: "Kitchen Manager",
  ProgrammingManager: "Programming Manager"
};

var CLIENT_NAME = exports.CLIENT_NAME = {
  CINEMA_AKIL: "Cinema Akil",
  EMPIRE: "empire",
  STUESSIHOF: "stuessihof",
  XANADU: "xanadu",
  PETRO: "petro",
  IRAQ: "Iraq",
  LEBANON: "lebanon",
  BILDHAUS: "bildhaus",
  QFX: "qfx",
  STAR: "starcinemas"
};

var CLIENT_NAMES_OBJ = exports.CLIENT_NAMES_OBJ = {
  empire_combo: ["empire", "petro", "Iraq", "starcinemas", "lebanon"],
  empire_iraq: ["empire", "Iraq"],
  multiple_ticket_clients: ["bildhaus", "carnival"],
  empire_iraq_lebanon: ["empire", "Iraq", "lebanon"],
  empire_clients: ["empire", "Iraq", "lebanon", "petro"],
  iraq: ["Iraq"],
  empire: ["empire"],
  xanadu: ["xanadu"],
  petro: ["petro"],
  stuessihof: ["stuessihof"],
  lebanon: ["lebanon"],
  bildhaus: ["bildhaus"],
  qfx: ["qfx"],
  star: ["starcinemas"],
  carnival: ["carnival"],
  bildhaus_qfx: ["bildhaus", "qfx"]
};

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var navLists = [{
  id: 1,
  name: "Booking Report - Summary",
  url: "/booking-summary"
}, {
  id: 2,
  name: "Transaction Hourly",
  url: "/transaction-hourly"
}, {
  id: 3,
  name: "Cinemawise Sales Summary",
  url: "/cinema-wise-sales"
}, {
  id: 4,
  name: "Moviewise - Summary",
  url: "/movie-wise-sales"
}, {
  id: 5,
  name: "Sales Report",
  url: "/sales-summary"
},
// {
//   id: 6,
//   name: "Complimentary Report",
//   url: "/booking-summary",
// },
{
  id: 7,
  name: "Schedule Report",
  url: "/schedule-report"
}, {
  id: 8,
  name: "FB Sale Summary",
  url: "/fb-sale-summary"
}, {
  id: 9,
  name: "Occupancy Report",
  url: "/occupancy-report"
}, {
  id: 10,
  name: "Week Wise Movie History",
  url: "/week-wise-movie-history"
}, {
  id: 11,
  name: "Movie Summary Report",
  url: "/movie-summary-report"
}, {
  id: 12,
  name: "Movie Show Wise Report",
  url: "/movie-show-wise-report"
}, {
  id: 13,
  name: "Summary Report",
  url: "/new-summary"
}];

exports.default = navLists;

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARklEQVR4nO3WsQkAMQwEweu/LKmwd2wwOLZ+BlTAouQSAGDTSb7HrqeE1CkEAACuXly/PSWk7v8BAIAh67enhNQpBAB+awHE9RApipkrkgAAAABJRU5ErkJggg=="

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventBus = undefined;

__webpack_require__(619);

var _vue = __webpack_require__(86);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(807);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(871);

var _router2 = _interopRequireDefault(_router);

var _bootstrapVue = __webpack_require__(881);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _vueToasted = __webpack_require__(919);

var _vueToasted2 = _interopRequireDefault(_vueToasted);

var _vuejsDatepicker = __webpack_require__(920);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _vueLazyload = __webpack_require__(921);

var _vueLazyload2 = _interopRequireDefault(_vueLazyload);

__webpack_require__(922);

__webpack_require__(923);

__webpack_require__(924);

var _vueCookie = __webpack_require__(925);

var _vueCookie2 = _interopRequireDefault(_vueCookie);

var _veeValidate = __webpack_require__(927);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _utilMixin = __webpack_require__(928);

var _utilMixin2 = _interopRequireDefault(_utilMixin);

__webpack_require__(935);

__webpack_require__(936);

__webpack_require__(937);

__webpack_require__(938);

__webpack_require__(939);

__webpack_require__(940);

__webpack_require__(941);

var _index = __webpack_require__(106);

var _axios = __webpack_require__(105);

var _axios2 = _interopRequireDefault(_axios);

__webpack_require__(942);

var _vueMultiselect = __webpack_require__(943);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vueLoadingOverlay = __webpack_require__(944);

var _vueLoadingOverlay2 = _interopRequireDefault(_vueLoadingOverlay);

__webpack_require__(945);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue2.default.use(_vueCookie2.default);

_vue2.default.use(_veeValidate2.default);

// mixin

_vue2.default.component("multiselect", _vueMultiselect2.default);

// Import component

// Import stylesheet


// import VueChartJS from "vue-chartjs";
// Vue.use(VueChartJS);

_vue2.default.use(_vueLazyload2.default, {
  preLoad: 1.3,
  error: "/static/placeholder-image.png",
  loading: "/static/placeholder-image.png",
  attempt: 1
});

// added loader
_vue2.default.use(_vueLoadingOverlay2.default, {
  loader: "bars",
  color: "#c74c47",
  width: 70,
  zIndex: 9999,
  height: 50,
  backgroundColor: "#4b4b4b"
});
_vue2.default.mixin(_utilMixin2.default);
_vue2.default.use(_bootstrapVue2.default);
_vue2.default.component("Datepicker", _vuejsDatepicker2.default);

_vue2.default.config.productionTip = false;

// toast message
_vue2.default.use(_vueToasted2.default, {
  duration: 2000,
  position: "bottom-center",
  singleton: true,
  containerClass: "toast-message",
  className: "toastedContainer"
});

// Created the Event Bus for the call parent function
var EventBus = exports.EventBus = new _vue2.default();

// socket import

/* eslint-disable no-new */
var vm = new _vue2.default({
  el: "#app",
  router: _router2.default,
  template: "<App/>",
  components: {
    App: _App2.default
  }
});

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(296);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de38cd4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(868);
function injectStyle (ssrContext) {
  __webpack_require__(808)
}
var normalizeComponent = __webpack_require__(119)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de38cd4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 808:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3478ccb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__ = __webpack_require__(812);
var normalizeComponent = __webpack_require__(119)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3478ccb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-bg"},[_c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}}),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Loading")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_connection_lost_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47d4f830_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connection_lost_vue__ = __webpack_require__(815);
function injectStyle (ssrContext) {
  __webpack_require__(814)
}
var normalizeComponent = __webpack_require__(119)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_connection_lost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47d4f830_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connection_lost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 814:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 815:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-connection-lost"},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"alt":"Connection Lost","height":"75","src":__webpack_require__(816),"width":"75"}}),_vm._v(" "),_c('h6',{staticClass:"mb-1"},[_vm._v("Oops!")]),_vm._v(" "),_c('h6',{staticClass:"mb-5"},[_vm._v("Connection Lost")]),_vm._v(" "),_c('div',{staticClass:"proceed-btn"},[_c('button',{staticClass:"btn py-md-2 px-md-3",attrs:{"type":"button"},on:{"click":_vm.retry}},[_vm._v("\n        Retry\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b36e9d14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_globalModal_vue__ = __webpack_require__(819);
function injectStyle (ssrContext) {
  __webpack_require__(818)
}
var normalizeComponent = __webpack_require__(119)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b36e9d14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_globalModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 818:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 819:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-modal"},[_c('div',{staticClass:"modal-container"},[_c('header',[_vm._v("Alert")]),_vm._v(" "),_c('div',{staticClass:"global-modal-content"},[_c('h5',[_vm._v("Are you Sure you Want to delete this item?")])]),_vm._v(" "),_c('footer',{staticClass:"global-modal-footer"},[_c('button',{staticClass:"btn-blue mx-1"},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn-outline-blue mx-1"},[_vm._v("No")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 868:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',[(_vm.$route.path != '/reports' && _vm.$route.path != '/')?_c('div',{staticClass:"d-flex bgNavbarHeader justify-content-md-normal",style:(['Movie Summary Report', 'Movie Show Wise Report', 'Week Wise Movie History Report', 'Summary Report', 'Occupancy Report'].includes(_vm.$route.meta.subName) ? 'background-color: #1c2b46 !important;' : '')},[(_vm.$route.path !== '/')?_c('p',{staticClass:"backBtnContainer ml-2 ml-md-1 mt-1",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('img',{staticClass:"w-100 h-100",attrs:{"src":__webpack_require__(869),"alt":""}})]):_c('div',{staticClass:"pl-2"},[_c('img',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sidebar-1",modifiers:{"sidebar-1":true}}],staticClass:"ham_icon",attrs:{"alt":"Menu","src":__webpack_require__(617)}}),_vm._v(" "),_c('b-sidebar',{attrs:{"id":"sidebar-1","title":"","shadow":""}},[_c('div',{staticClass:"px-3 py-2 sub_menu"},[_c('p',{on:{"click":function($event){return _vm.homePage()}}},[_vm._v(" Home ")]),_vm._v(" "),_c('p',{style:(_vm.showAnalyticsMenu ? 'color:red' : ''),on:{"click":function($event){return _vm.toggleAnalyticsMenu()}}},[_vm._v("\n              Analytics Reports\n            ")]),_vm._v(" "),(_vm.showAnalyticsMenu)?_c('div',{staticClass:"analytics-submenu pl-3"},_vm._l((_vm.navBarItems),function(item){return _c('p',{key:item.id,staticClass:"sidebar-link",on:{"click":function($event){return _vm.navigate(item.url)}}},[_vm._v("\n                "+_vm._s(item.name)+"\n              ")])}),0):_vm._e()])])],1),_vm._v(" "),_c('p',{staticClass:"text-center my-0 module_name_container mx-auto mt-1",class:[
          ['Movie Summary Report', 'Movie Show Wise Report', 'Week Wise Movie History Report', 'Summary Report', 'Occupancy Report'].includes(_vm.$route.meta.subName) ? '' : 'text-light',
          _vm.$route.meta.subName === 'Week Wise Movie History Report' ? 'week-wise-title' : ''
        ],style:(['Movie Summary Report', 'Movie Show Wise Report', 'Week Wise Movie History Report', 'Summary Report', 'Occupancy Report'].includes(_vm.$route.meta.subName) ? 'color: #f3c300 !important;' : '')},[_vm._v(_vm._s(_vm.$route.meta.subName))]),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"40px","height":"25px"},attrs:{"src":__webpack_require__(870),"alt":""},on:{"click":function($event){return _vm.homePage()}}})]):_vm._e(),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 869:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDQ5MiA0OTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ5MiA0OTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiBmaWxsPSIjZmZmZmZmIj4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNNDY0LjM0NCwyMDcuNDE4bDAuNzY4LDAuMTY4SDEzNS44ODhsMTAzLjQ5Ni0xMDMuNzI0YzUuMDY4LTUuMDY0LDcuODQ4LTExLjkyNCw3Ljg0OC0xOS4xMjQKCQkJYzAtNy4yLTIuNzgtMTQuMDEyLTcuODQ4LTE5LjA4OEwyMjMuMjgsNDkuNTM4Yy01LjA2NC01LjA2NC0xMS44MTItNy44NjQtMTkuMDA4LTcuODY0Yy03LjIsMC0xMy45NTIsMi43OC0xOS4wMTYsNy44NDQKCQkJTDcuODQ0LDIyNi45MTRDMi43NiwyMzEuOTk4LTAuMDIsMjM4Ljc3LDAsMjQ1Ljk3NGMtMC4wMiw3LjI0NCwyLjc2LDE0LjAyLDcuODQ0LDE5LjA5NmwxNzcuNDEyLDE3Ny40MTIKCQkJYzUuMDY0LDUuMDYsMTEuODEyLDcuODQ0LDE5LjAxNiw3Ljg0NGM3LjE5NiwwLDEzLjk0NC0yLjc4OCwxOS4wMDgtNy44NDRsMTYuMTA0LTE2LjExMmM1LjA2OC01LjA1Niw3Ljg0OC0xMS44MDgsNy44NDgtMTkuMDA4CgkJCWMwLTcuMTk2LTIuNzgtMTMuNTkyLTcuODQ4LTE4LjY1MkwxMzQuNzIsMjg0LjQwNmgzMjkuOTkyYzE0LjgyOCwwLDI3LjI4OC0xMi43OCwyNy4yODgtMjcuNnYtMjIuNzg4CgkJCUM0OTIsMjE5LjE5OCw0NzkuMTcyLDIwNy40MTgsNDY0LjM0NCwyMDcuNDE4eiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 870:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSA8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjE3IiB2aWV3Qm94PSIwIDAgMjAgMTciPgogIDxwYXRoIGlkPSJJY29uIiBkPSJNNzMzLTMyOHYtNmg0djZoNXYtOGgzbC0xMC05LTEwLDloM3Y4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcyNSAzNDUpIiBmaWxsPSIjZDlkOWQ5IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+IC0tPgoKCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyMCAxNyI+CiAgPHBhdGggaWQ9Ikljb24iIGQ9Ik03MzMtMzI4di02aDR2Nmg1di04aDNsLTEwLTktMTAsOWgzdjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzI1IDM0NSkiIGZpbGw9IiNkOWQ5ZDkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSJibGFjayIgLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(86);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(872);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _config = __webpack_require__(106);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: "hash",
  routes: [{
    path: "/reports",
    name: "ReportsHome",
    // meta: {
    //   subName: `${CLIENT_NAME ? CLIENT_NAME : "Star"} Cinemas Reports`,
    // },
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 948));
    }
  }, {
    path: "/",
    name: "LoginPage",
    // meta: {
    //   subName: `${CLIENT_NAME ? CLIENT_NAME : "Star"} Cinemas Reports`,
    // },
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 949));
    }
  }, {
    path: "/booking-summary",
    name: "BookingSummary",
    meta: { subName: "Booking Summary" },

    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 950));
    }
  }, {
    path: "/transaction-hourly",
    name: "transactionHourly",
    meta: { subName: "Transaction Hourly" },

    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 951));
    }
  }, {
    path: "/transaction-hourly/:hour/:fromDate/:toDate",
    name: "transactionHourlyDetailed",
    meta: { subName: "Transaction Hourly" },

    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 952));
    }
  }, {
    path: "/cinema-wise-sales",
    name: "CinemaWiseSalesRecords",
    meta: { subName: "Cinema Wise Sales" },

    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 953));
    }
  }, {
    path: "/cinema-wise-sales/:cinema_id/:fromDate/:toDate",
    name: "CinemaWiseMovieSales",
    meta: { subName: "Cinema Wise Sales" },

    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 954));
    }
  }, {
    path: "/movie-wise-sales",
    name: "MovieWiseSalesRecords",
    meta: { subName: "Movie Wise Sales" },

    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 955));
    }
  }, {
    path: "/movie-wise-sales/:md_id/:fromDate/:toDate",
    name: "MovieWiseCinemaSales",
    meta: { subName: "Movie Wise Sales" },

    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 956));
    }
  }, {
    path: "/sales-summary",
    name: "DailySalesReport",
    meta: { subName: "Daily Sales Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 957));
    }
  }, {
    path: "/sales-summary/:cinema_id/:fromDate/:toDate",
    name: "DailySalesDetailedReport",
    meta: { subName: "Daily Sales Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 958));
    }
  }, {
    path: "/schedule-report",
    name: "ScheduleReportVenue",
    meta: { subName: "Schedule Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 959));
    }
  }, {
    path: "/schedule-report/:cinema_id",
    name: "ScheduleReportVenueBasedMovie",
    meta: { subName: "Schedule Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 960));
    }
  }, {
    path: "/schedule-report/:cinema_id/:md_id",
    name: "cinemaMovieSchedules",
    meta: { subName: "Schedule Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 961));
    }
  }, {
    path: "/schedule-movie-report/:md_id",
    name: "movieCinemaSchedules",
    meta: { subName: "Schedule Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 962));
    }
  }, {
    path: "/schedule-movie-report/:md_id/:cinema_id",
    name: "movieScheduledCinemaScreen",
    meta: { subName: "Schedule Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 963));
    }
  }, {
    path: "/fb-sale-summary",
    name: "FnBSalesSummary",
    meta: { subName: "FB Sale Summary" },

    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 964));
    }
  }, {
    path: "/fb-sale-summary/:source_type/:fromDate/:toDate",
    name: "FnBSalesCinemaSummary",
    meta: { subName: "FB Sale Summary" },

    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 965));
    }
  }, {
    path: "/fb-sale-summary/:cinema_id/:source_type/:fromDate/:toDate",
    name: "FnBSalesItemCinemaWiseSummary",
    meta: { subName: "FB Sale Summary" },

    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 966));
    }
  }, {
    path: "/occupancy-report",
    name: "cinemaOccupancyReport",
    meta: { subName: "Occupancy Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 967));
    }
  }, {
    path: "/occupancy-report/:cinema_id",
    name: "movieOccupancyReport",
    meta: { subName: "Occupancy Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 968));
    }
  }, {
    path: "/occupancy-report/:cinema_id/:md_id",
    name: "screenOccupancyReport",
    meta: { subName: "Occupancy Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 969));
    }
  }, {
    path: "/week-wise-movie-history",
    name: "weekWiseMovieHistory",
    meta: { subName: "Week Wise Movie History Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 970));
    }
  }, {
    path: "/movie-summary-report",
    name: "movieSummaryReport",
    meta: { subName: "Movie Summary Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 971));
    }
  }, {
    path: "/movie-show-wise-report",
    name: "movieShowWiseReport",
    meta: { subName: "Movie Show Wise Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 972));
    }
  }, {
    path: "/new-summary",
    name: "SummaryReport",
    meta: { subName: "Summary Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 973));
    }
  }],

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach(function (to, from, next) {
  console.log({ to: to, from: from });
  var isAuthenticated = localStorage.getItem("IsloggedIn") == "Y";

  if (isAuthenticated && to.name == "LoginPage") next({ name: "ReportsHome" });

  if (to.name !== "LoginPage" && !isAuthenticated) next({ name: "LoginPage" });else next();
});

exports.default = router;

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 318,
	"./af.js": 318,
	"./ar": 319,
	"./ar-dz": 320,
	"./ar-dz.js": 320,
	"./ar-kw": 321,
	"./ar-kw.js": 321,
	"./ar-ly": 322,
	"./ar-ly.js": 322,
	"./ar-ma": 323,
	"./ar-ma.js": 323,
	"./ar-ps": 324,
	"./ar-ps.js": 324,
	"./ar-sa": 325,
	"./ar-sa.js": 325,
	"./ar-tn": 326,
	"./ar-tn.js": 326,
	"./ar.js": 319,
	"./az": 327,
	"./az.js": 327,
	"./be": 328,
	"./be.js": 328,
	"./bg": 329,
	"./bg.js": 329,
	"./bm": 330,
	"./bm.js": 330,
	"./bn": 331,
	"./bn-bd": 332,
	"./bn-bd.js": 332,
	"./bn.js": 331,
	"./bo": 333,
	"./bo.js": 333,
	"./br": 334,
	"./br.js": 334,
	"./bs": 335,
	"./bs.js": 335,
	"./ca": 336,
	"./ca.js": 336,
	"./cs": 337,
	"./cs.js": 337,
	"./cv": 338,
	"./cv.js": 338,
	"./cy": 339,
	"./cy.js": 339,
	"./da": 340,
	"./da.js": 340,
	"./de": 341,
	"./de-at": 342,
	"./de-at.js": 342,
	"./de-ch": 343,
	"./de-ch.js": 343,
	"./de.js": 341,
	"./dv": 344,
	"./dv.js": 344,
	"./el": 345,
	"./el.js": 345,
	"./en-au": 346,
	"./en-au.js": 346,
	"./en-ca": 347,
	"./en-ca.js": 347,
	"./en-gb": 348,
	"./en-gb.js": 348,
	"./en-ie": 349,
	"./en-ie.js": 349,
	"./en-il": 350,
	"./en-il.js": 350,
	"./en-in": 351,
	"./en-in.js": 351,
	"./en-nz": 352,
	"./en-nz.js": 352,
	"./en-sg": 353,
	"./en-sg.js": 353,
	"./eo": 354,
	"./eo.js": 354,
	"./es": 355,
	"./es-do": 356,
	"./es-do.js": 356,
	"./es-mx": 357,
	"./es-mx.js": 357,
	"./es-us": 358,
	"./es-us.js": 358,
	"./es.js": 355,
	"./et": 359,
	"./et.js": 359,
	"./eu": 360,
	"./eu.js": 360,
	"./fa": 361,
	"./fa.js": 361,
	"./fi": 362,
	"./fi.js": 362,
	"./fil": 363,
	"./fil.js": 363,
	"./fo": 364,
	"./fo.js": 364,
	"./fr": 365,
	"./fr-ca": 366,
	"./fr-ca.js": 366,
	"./fr-ch": 367,
	"./fr-ch.js": 367,
	"./fr.js": 365,
	"./fy": 368,
	"./fy.js": 368,
	"./ga": 369,
	"./ga.js": 369,
	"./gd": 370,
	"./gd.js": 370,
	"./gl": 371,
	"./gl.js": 371,
	"./gom-deva": 372,
	"./gom-deva.js": 372,
	"./gom-latn": 373,
	"./gom-latn.js": 373,
	"./gu": 374,
	"./gu.js": 374,
	"./he": 375,
	"./he.js": 375,
	"./hi": 376,
	"./hi.js": 376,
	"./hr": 377,
	"./hr.js": 377,
	"./hu": 378,
	"./hu.js": 378,
	"./hy-am": 379,
	"./hy-am.js": 379,
	"./id": 380,
	"./id.js": 380,
	"./is": 381,
	"./is.js": 381,
	"./it": 382,
	"./it-ch": 383,
	"./it-ch.js": 383,
	"./it.js": 382,
	"./ja": 384,
	"./ja.js": 384,
	"./jv": 385,
	"./jv.js": 385,
	"./ka": 386,
	"./ka.js": 386,
	"./kk": 387,
	"./kk.js": 387,
	"./km": 388,
	"./km.js": 388,
	"./kn": 389,
	"./kn.js": 389,
	"./ko": 390,
	"./ko.js": 390,
	"./ku": 391,
	"./ku-kmr": 392,
	"./ku-kmr.js": 392,
	"./ku.js": 391,
	"./ky": 393,
	"./ky.js": 393,
	"./lb": 394,
	"./lb.js": 394,
	"./lo": 395,
	"./lo.js": 395,
	"./lt": 396,
	"./lt.js": 396,
	"./lv": 397,
	"./lv.js": 397,
	"./me": 398,
	"./me.js": 398,
	"./mi": 399,
	"./mi.js": 399,
	"./mk": 400,
	"./mk.js": 400,
	"./ml": 401,
	"./ml.js": 401,
	"./mn": 402,
	"./mn.js": 402,
	"./mr": 403,
	"./mr.js": 403,
	"./ms": 404,
	"./ms-my": 405,
	"./ms-my.js": 405,
	"./ms.js": 404,
	"./mt": 406,
	"./mt.js": 406,
	"./my": 407,
	"./my.js": 407,
	"./nb": 408,
	"./nb.js": 408,
	"./ne": 409,
	"./ne.js": 409,
	"./nl": 410,
	"./nl-be": 411,
	"./nl-be.js": 411,
	"./nl.js": 410,
	"./nn": 412,
	"./nn.js": 412,
	"./oc-lnc": 413,
	"./oc-lnc.js": 413,
	"./pa-in": 414,
	"./pa-in.js": 414,
	"./pl": 415,
	"./pl.js": 415,
	"./pt": 416,
	"./pt-br": 417,
	"./pt-br.js": 417,
	"./pt.js": 416,
	"./ro": 418,
	"./ro.js": 418,
	"./ru": 419,
	"./ru.js": 419,
	"./sd": 420,
	"./sd.js": 420,
	"./se": 421,
	"./se.js": 421,
	"./si": 422,
	"./si.js": 422,
	"./sk": 423,
	"./sk.js": 423,
	"./sl": 424,
	"./sl.js": 424,
	"./sq": 425,
	"./sq.js": 425,
	"./sr": 426,
	"./sr-cyrl": 427,
	"./sr-cyrl.js": 427,
	"./sr.js": 426,
	"./ss": 428,
	"./ss.js": 428,
	"./sv": 429,
	"./sv.js": 429,
	"./sw": 430,
	"./sw.js": 430,
	"./ta": 431,
	"./ta.js": 431,
	"./te": 432,
	"./te.js": 432,
	"./tet": 433,
	"./tet.js": 433,
	"./tg": 434,
	"./tg.js": 434,
	"./th": 435,
	"./th.js": 435,
	"./tk": 436,
	"./tk.js": 436,
	"./tl-ph": 437,
	"./tl-ph.js": 437,
	"./tlh": 438,
	"./tlh.js": 438,
	"./tr": 439,
	"./tr.js": 439,
	"./tzl": 440,
	"./tzl.js": 440,
	"./tzm": 441,
	"./tzm-latn": 442,
	"./tzm-latn.js": 442,
	"./tzm.js": 441,
	"./ug-cn": 443,
	"./ug-cn.js": 443,
	"./uk": 444,
	"./uk.js": 444,
	"./ur": 445,
	"./ur.js": 445,
	"./uz": 446,
	"./uz-latn": 447,
	"./uz-latn.js": 447,
	"./uz.js": 446,
	"./vi": 448,
	"./vi.js": 448,
	"./x-pseudo": 449,
	"./x-pseudo.js": 449,
	"./yo": 450,
	"./yo.js": 450,
	"./zh-cn": 451,
	"./zh-cn.js": 451,
	"./zh-hk": 452,
	"./zh-hk.js": 452,
	"./zh-mo": 453,
	"./zh-mo.js": 453,
	"./zh-tw": 454,
	"./zh-tw.js": 454
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 880;

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineDateAndTime = undefined;

var _vue = __webpack_require__(86);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.filter("time", function (value) {
  var is24HrFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (value) {
    var date = new Date(Date.parse(value));
    var hours = date.getHours();
    var min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
    if (!is24HrFormat) {
      var time = hours > 12 ? "AM" : "PM";
      hours = hours % 12 || 12;
      return hours + ":" + min + " " + time;
    }
    return hours + ":" + min;
  }
});

_vue2.default.filter("timeFormat", function (value) {
  if (value) {
    var dateString = combineDateAndTime(value);
    var format = window.localStorage.getItem("TimeFormat") ? window.localStorage.getItem("TimeFormat") : "HH:mm";
    if (format) {
      return (0, _moment2.default)(dateString).format(format);
    } else {
      return (0, _moment2.default)(dateString).format("HH:mm");
    }
  } else {
    return "-";
  }
});

_vue2.default.filter("weekOfMonth", function (value) {
  if (value) {
    var date = (0, _moment2.default)(value);
    var weekInYearIndex = date.week();
    if (date.year() !== date.weekYear()) {
      weekInYearIndex = date.clone().subtract(1, "week").week() + 1;
    }
    var weekIndex = weekInYearIndex - (0, _moment2.default)(date).startOf("month").week() + 1;
    return weekIndex;
  } else {
    return "-";
  }
});

_vue2.default.filter("timefornotification", function (value) {
  var is24HrFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (value) {
    var date = new Date(Date.parse(value));
    var hours = date.getHours();
    var min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
    if (!is24HrFormat) {
      var time = hours < 12 ? "AM" : "PM";
      hours = hours % 12 || 12;
      return hours + ":" + min + " " + time;
    }
    return hours + ":" + min;
  }
});

_vue2.default.filter("format12hours", function (value) {
  if (!value) return "-";else if (value) return value ? (0, _moment2.default)(value, ["HH:mm"]).format("h:mm A") : "-";
});

_vue2.default.filter("format24hours", function (value) {
  if (!value) return "-";else if (value) return value ? (0, _moment2.default)(value, ["h:mm A"]).format("HH:mm") : "-";
});

////////////////////////
_vue2.default.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

_vue2.default.filter("uppercase", function (value) {
  if (!value) return value || "";
  return value.toUpperCase();
});

_vue2.default.filter("activeParse", function (value) {
  if (!value) return value || "";
  return value === "Y" ? "Yes" : value === "N" ? "No" : "";
});
_vue2.default.filter("dateparse-movies", function (value) {
  console.log("value", value);
  console.log("value1", (0, _moment2.default)(value, "DD/MM/YYYY"));
  value = (0, _moment2.default)(value, "DD/MM/YYYY");
  if (!value) return "-";else if (value === "Invalid date") return "-";else return value ? (0, _moment2.default)(value).format("DD-MM-YYYY") === "Invalid date" ? "-" : (0, _moment2.default)(value).format("DD MMM YYYY") : "-";
});

_vue2.default.filter("dateparse", function (value) {
  if (!value) return "-";else if (value === "Invalid date") return "-";else if ((0, _moment2.default)(value, "DD-MM-YYYY HH:mm", true).isValid()) return value ? (0, _moment2.default)(value, "DD-MM-YYYY HH:mm").format("DD MMM YYYY") : "-";
  //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
  //this is changed acc to mams decision
  else return value ? (0, _moment2.default)(value).format("DD-MM-YYYY") === "Invalid date" ? "-" : (0, _moment2.default)(value).format("DD MMM YYYY") : "-";
});
_vue2.default.filter("dayparse", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value, "DD-MM-YYYY").calendar(null, {
    lastDay: "[Yesterday]",
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    lastWeek: "[last] dddd",
    nextWeek: "dddd",
    sameElse: "dddd"
  }) : "-";
});

_vue2.default.filter("daynumber", function (value) {
  if (!value) return "-";else if (value && (0, _moment2.default)(value).format("dddd") === "Friday") return "1";else if (value && (0, _moment2.default)(value).format("dddd") === "Saturday") return "2";else if (value && (0, _moment2.default)(value).format("dddd") === "Sunday") return "3";else if (value && (0, _moment2.default)(value).format("dddd") === "Monday") return "4";else if (value && (0, _moment2.default)(value).format("dddd") === "Tuesday") return "5";else if (value && (0, _moment2.default)(value).format("dddd") === "Wednesday") return "6";else if (value && (0, _moment2.default)(value).format("dddd") === "Thursday") return "7";
});

// moment().format("dddd")
_vue2.default.filter("daydate", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("ddd") + " " + (0, _moment2.default)(value).format("DD") : "-";
});

_vue2.default.filter("fulldateparse", function (value) {
  var isInvalid = String(value).toLowerCase();
  if (isInvalid.includes('invalid') || isInvalid.includes('null') || isInvalid.includes('undefined')) return '-';

  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("DD-MM-YYYY HH:MM") : "-";
});

_vue2.default.filter("timeparse", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("LT") : "-";
});

_vue2.default.filter("temptimeparse", function () {});

_vue2.default.filter("getDay", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("dddd") : "-";
});

_vue2.default.filter("getMonth", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("MMMM") : "-";
});

_vue2.default.filter("getDayDigit", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("Do") : "-";
});

_vue2.default.filter("dayonly3", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("ddd") : "-";
});

_vue2.default.filter("timeparseAmPm", function (value) {
  // console.log('value :', value);
  if (!value) return "-";else return value ? (0, _moment2.default)((0, _moment2.default)(new Date()).format("DD-MM-YYYY") + " " + value, "DD-MM-YYYY HH:mm").format("h:mm A") : "-";
});

// Vue.filter('datetimeparseAmPm', function (value) {
//     console.log('value :', value);
//     if (!value) return '-'
//     else return value ? moment(`${moment(new Date()).format('DD-MM-YYYY')} ${value}`, 'DD-MM-YYYY HH:mm').format('h:mm A') : '-'
// });

_vue2.default.filter("fulldatemonparse", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("DD-MMM-YYYY HH:mm") : "-";
});

_vue2.default.filter("dateFormat", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("YYYY-MM-DD") : "-";
});

_vue2.default.filter("time", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("HH:mm") : "-";
});

_vue2.default.filter("fulldaydateparse", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("MMMM Do YYYY, HH:mm") : "-";
});

_vue2.default.filter("RoundOff", function (value) {
  if (!value) return "0";else return value ? Math.round(value * 100) / 100 : "-";
});

_vue2.default.filter("TimeStamptoDate", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value * 1000).format("YYYY-MM-DD") : "-";
});

_vue2.default.filter("convertTo12Hours", function (value) {
  if (!value) return "-";else {
    // Check correct time format and split into components
    value = value.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [value];

    if (value.length > 1) {
      // If time format correct
      value = value.slice(1); // Remove full string match value
      value[5] = +value[0] < 12 ? " AM" : " PM"; // Set AM/PM
      value[0] = +value[0] % 12 || 12; // Adjust hours
    }
    return value.join(""); // return adjusted time or original strin
  }
});

_vue2.default.filter("TimeStamptoTime", function (value) {
  if (!value) return "-";else if (value.toString().length == 10) return value ? (0, _moment2.default)(value * 1000).format("hh:mm A") : "-";else return value ? (0, _moment2.default)(value).format("hh:mm A") : "-";
});

_vue2.default.filter("filterNullUndefined", function (value) {
  if (!value) return "-";
  return value;
});

_vue2.default.filter("negativeValue", function (value) {
  if (!value) return parseFloat(0).toFixed(2);
  return "" + ("-" + value);
});

_vue2.default.filter("dateParseYYYYMMDD", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("YYYY-MM-DD HH:mm") : "-";
});

_vue2.default.filter("orderStatusTag", function (value) {
  if (value == "Complete") {
    return "Ready";
  } else if (value == "Cancel") {
    return "Cancelled";
  } else {
    return value;
  }
});

var combineDateAndTime = exports.combineDateAndTime = function combineDateAndTime(time) {
  var timeString = time;
  var dateString = (0, _moment2.default)().format("YYYY-MM-DD");
  var combined = new Date(dateString + " " + timeString);

  return combined;
};

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(161);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(600);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(601);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(604);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(262);

var _keys2 = _interopRequireDefault(_keys);

var _lodash = __webpack_require__(254);

var _lodash2 = _interopRequireDefault(_lodash);

var _vue = __webpack_require__(86);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(106);

var _constant = __webpack_require__(929);

var _constant2 = _interopRequireDefault(_constant);

var _currencyFormat = __webpack_require__(930);

var _Languages = __webpack_require__(931);

var _axios = __webpack_require__(105);

var _axios2 = _interopRequireDefault(_axios);

var _AuthenticationService = __webpack_require__(932);

var _MasterService = __webpack_require__(255);

var _MasterService2 = _interopRequireDefault(_MasterService);

var _LogService = __webpack_require__(933);

var _LogService2 = _interopRequireDefault(_LogService);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _Role = __webpack_require__(610);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var beforeMount = function beforeMount() {
  // this.$store.dispatch("fetchGlobalOptions");
  // this.$store.dispatch("fetchOrgDetails");
};
// import { getLangSpecificContent } from "@/helper/LanguageHelperV2";


var userDetailsArray = {
  cinema_id: null,
  email_id: null,
  first_name: null,
  last_name: null,
  middle_name: null,
  mobile_no: null,
  role_id: null,
  user_id: null,
  username: null,
  role_name: null,
  distributor_id: null,
  cine_name: null,
  cine_direct_sale: null,
  cine_include_float_amount: null,
  cine_sell_fnb_in_boxoffice: null,
  pos_location_access: null,
  is_premier_kitchen_user: "N"
};
var _data = function _data() {
  return {
    LOADING: null,
    AdminError: "Sorry! Something went wrong. kindly contact your administrator",
    GridViewFlag: false,
    NoRecords: "NoRecords",
    BASE_URL: _constant2.default.imageBaseURL,
    imageBaseURL: _constant2.default.imageBaseURL,
    imageS3BaseURL: _constant2.default.imageS3BaseURL,
    data_loading: false,
    usersArray: (0, _keys2.default)(userDetailsArray),
    UsersDetails: (0, _extends3.default)({}, userDetailsArray),
    OrganizationGlobalOptions: [],
    secureStore: {
      set: _AuthenticationService.authenticationService.set,
      get: _AuthenticationService.authenticationService.get,
      remove: function remove(key) {
        window.localStorage.removeItem(key);
      }
    },
    toursShownOnPage: [],
    getMycinemaStatus: "N"
  };
};
var computed = {
  globaloptionsArr: function globaloptionsArr() {
    return this.$store.getters.getGlobalOptions;
  },
  _getCountryList: function _getCountryList() {
    return function (key, Id) {
      return [];
    };
  },
  curr_code_mixin: function curr_code_mixin() {
    return this.$store.getters.getCurrencyData["curr_code"];
  },
  currency: function currency() {
    return this.$store.getters.getCurrencyData;
  },
  GetRoleId: function GetRoleId() {
    var _authenticationServic = _AuthenticationService.authenticationService.get("USINFO"),
        role_id = _authenticationServic.role_id;

    return role_id;
  },
  _DateFormat: function _DateFormat() {
    return _constant2.default.dateFormat;
  },

  // currFormat() {
  //   let cFormat;
  //   let precesion;
  //   let global_options_latest = this.$store.getters.getGlobalOptions;
  //   cFormat = global_options_latest
  //     ? global_options_latest.find((x) => {
  //         return x.go_key == "CURR_FORMAT";
  //       })
  //     : null;
  //   precesion = global_options_latest
  //     ? global_options_latest.find((x) => {
  //         return x.go_key == "MIN_FRACTION_DIGITS";
  //       })
  //     : 2;
  //   if (cFormat && cFormat.go_value) {
  //     cFormat = cFormat.go_value;
  //   } else {
  //     cFormat = "en-US";
  //   }
  //   if (precesion && precesion.go_value) {
  //     precesion = precesion.go_value;
  //   } else {
  //     precesion = 2;
  //   }

  //   let CLIENT_SETUP_NAME = ""

  //   const CLIENTINFO = global_options_latest
  //     ? global_options_latest.find((x) => {
  //         return x.go_key == "CLIENT_SETUP_NAME";
  //       })
  //     : null;

  //     if(CLIENTINFO && CLIENTINFO.go_value) {
  //       CLIENT_SETUP_NAME = CLIENTINFO.go_value
  //     }

  //     console.log('CLIENT_SETUP_NAME', CLIENT_SETUP_NAME);
  //     console.log('CLIENT_NAME', this.CLIENT_NAME);


  //   if(CLIENT_SETUP_NAME == "starcinemas") {
  //     cFormat ='en-IN';
  //     precesion = 0;
  //   } else {
  //     precesion = precesion || 3;
  //   }
  //   return getNumberFormatter(cFormat, precesion);
  // },
  currFormat: function currFormat() {
    var cFormat = void 0;
    var precesion = void 0;
    var global_options_latest = [];
    var orgName = localStorage.getItem("setUpName");
    this.isStarClient = orgName.includes("starcinemas") ? true : false;
    var CLIENT_SETUP_NAME = "";
    if (CLIENT_SETUP_NAME == "starcinemas") {
      precesion = 0;
      cFormat = 'en-IN';
    } else {
      precesion = 2;
      cFormat = "en-US";
    }
    return (0, _currencyFormat.getNumberFormatter)(cFormat, precesion);
  },
  currFormat4: function currFormat4() {
    var cFormat = void 0;
    var precesion = void 0;
    var global_options_latest = [];
    var orgName = localStorage.getItem("setUpName");
    this.isStarClient = orgName.includes("starcinemas") ? true : false;
    var CLIENT_SETUP_NAME = "";
    precesion = 0;
    cFormat = "en-US";
    return (0, _currencyFormat.getNumberFormatter)(cFormat, precesion);
  },
  currFormat3: function currFormat3() {
    var cFormat = void 0;
    var precesion = void 0;
    var global_options_latest = this.$store.getters.getGlobalOptions;
    cFormat = global_options_latest ? global_options_latest.find(function (x) {
      return x.go_key == "CURR_FORMAT";
    }) : null;
    precesion = global_options_latest ? global_options_latest.find(function (x) {
      return x.go_key == "MIN_FRACTION_DIGITS";
    }) : null;
    if (cFormat && cFormat.go_value) {
      cFormat = cFormat.go_value;
    } else {
      cFormat = "en-US";
    }
    if (precesion && precesion.go_value) {
      precesion = precesion.go_value;
    } else {
      precesion = 2;
    }
    precesion = 3;
    return (0, _currencyFormat.getNumberFormatter)(cFormat, precesion);
  },
  CLIENT_SETUP_NAME: function CLIENT_SETUP_NAME() {
    return this.$store.getters.CLIENT_SETUP_NAME;
  },
  POS_AUDIT_LOGS_ACTIVE: function POS_AUDIT_LOGS_ACTIVE() {
    return this.$store.getters.POS_AUDIT_LOGS_ACTIVE;
  }
};

var getFirstUserData = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user_id) {
    var _ref2, data;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _MasterService2.default.GetUserInfoById({ user_id: user_id });

          case 2:
            _ref2 = _context.sent;
            data = _ref2.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getFirstUserData(_x) {
    return _ref.apply(this, arguments);
  };
}();
var methods = {
  sendAuditLogs: function sendAuditLogs(payload) {
    if (this.POS_AUDIT_LOGS_ACTIVE == "Y") {
      var logObj = (0, _extends3.default)({
        user_name: null,
        user_id: this.getUserDetail("user_id"),
        cinema_id: this.getCinemaId(),
        action: null,
        page_name: null,
        logDateTime: null,
        api_name: window.location.hash,
        ip: null,
        country_name: null,
        country_code: null,
        latitude: null,
        longitude: null,
        currency_code: null,
        currency_name: null
      }, payload);
      _LogService2.default.SendLog(logObj).then(function (response) {
        var data = response.data;

        if (data && data.status) {
          console.log("Log Inserted");
        } else {
          console.error("Status Error on sendLogs :", data.message);
        }
      }).catch(function (error) {
        console.error("Catch Error on sendLogs :", error);
      });
    }
  },
  authorizeClient: function authorizeClient(clientNames) {
    var isShow = false;
    var globaloptionsArr = this.globaloptionsArr;
    var clientSetupName = globaloptionsArr.find(function (globalOption) {
      return globalOption.go_key == "CLIENT_SETUP_NAME";
    })["go_value"];

    if (clientNames.length > 0 && clientSetupName) {
      isShow = clientNames.includes(clientSetupName);
    }
    console.log("this.$store.getters.CLIENT_SETUP_NAME", clientSetupName, clientNames, isShow, "from mixins");
    return isShow;
  },

  showLoading: function showLoading() {
    var _this = this;

    this.hideLoading(true);
    document.body.classList.add("sales-report-loading");
    this.$nextTick(function () {
      _this.LOADING = _this.$loading.show();
    });
  },
  hideLoading: function hideLoading() {
    var _this2 = this;

    var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    document.body.classList.remove("sales-report-loading");
    if (!immediate) {
      this.$nextTick(function () {
        if (_this2.LOADING) _this2.LOADING.hide();
      });
    } else {
      if (this.LOADING) this.LOADING.hide();
    }
  },
  getRequestBody: function getRequestBody() {
    var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "GET";
    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var Methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var payload = {};
    (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var promises;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              promises = array.map(function (x) {
                payload[x.fieldname] = x.fieldvalue;
              });
              _context2.next = 3;
              return _promise2.default.all(promises);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }))();
    if (method == "POST") {
      return {
        url: Methods[method] + Methods["tableName"], // + Methods["urlKey"],
        method: method,
        payload: payload
      };
    } else if (method == "PUT") {
      var url = null;
      console.log("Method :", Methods["params"]);
      if (Methods["params"]) {
        url = Methods[method] + Methods["tableName"] + ("/" + Methods["params"]["id"]);
      } else {
        url = Methods[method] + Methods["tableName"];
      }
      console.log("url :", url);

      return {
        url: url,
        method: "PUT",
        payload: payload
      };
    } else if (method == "GET") {
      var _url = null;
      if (Methods["params"]) {
        _url = Methods[method] + Methods["tableName"] + ("/" + Methods["params"]["id"]);
      } else {
        _url = Methods[method] + Methods["tableName"];
      }

      return {
        url: _url,
        method: "GET",
        payload: {}
      };
    } else if (method == "GET_ONE") {
      var _url2 = null;
      if (Methods["params"]) {
        _url2 = Methods[method] + Methods["tableName"] + ("/" + Methods["params"]["id"]);
      } else {
        _url2 = Methods[method] + Methods["tableName"];
      }

      return {
        url: _url2,
        method: "GET",
        payload: {}
      };
    } else {
      return {
        url: "",
        method: "GET",
        payload: {}
      };
    }
  },
  /**
   * How to use Ref: [https://github.com/vuejs/vue/issues/11088#issuecomment-630287153]
   *  <template>
   *    <div>
   *      {{ getSafe(() => obj.foo.bar) }} ............................ <!-- returns 'baz' -->
   *      {{ getSafe(() => obj.foo.doesNotExist) }} ................... <!-- returns undefined -->
   *      {{ getSafe(() => obj.foo.doesNotExist, 'fallbackValue') }}... <!-- returns 'fallbackValue' -->
   *    </div>
   *  </template>
   */
  getSafe: function getSafe(fn) {
    var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var useFallbackForFalsyGetSafeValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    try {
      var result = fn();

      if (!result && useFallbackForFalsyGetSafeValue) {
        result = fallbackValue;
      }

      return result;
    } catch (e) {
      return fallbackValue;
    }
  },
  validateShowCinema: function validateShowCinema(cinema_id) {
    console.log("VALIDATING CINEMA...", cinema_id, _AuthenticationService.authenticationService.get("USINFO").cinema_id);
    var loggedCinemaId = window.localStorage.getItem("cinema_id");
    var userId = _AuthenticationService.authenticationService.get("USINFO").user_id;
    var status = true;
    if (cinema_id && loggedCinemaId) {
      if (cinema_id == _AuthenticationService.authenticationService.get("USINFO").cinema_id && loggedCinemaId == cinema_id) {
        status = true;
      } else {
        status = false;
      }
    } else {
      status = false;
    }
    if (!status) {
      this.$store.dispatch("onSetAndSendLog", {
        action: "Validate Cinema ID FALIED WE GET SHOW CINEMA ID " + cinema_id + " but USER CINEMA ID IS " + loggedCinemaId + " and user id is " + userId,
        page_name: "POS booking",
        api_name: window.location.hash
      });
    }
    console.log("VALIDATE CINEMA STATUS", status);
    return status;
  },
  getNegativeValue: function getNegativeValue(value) {
    if (value) {
      return "-" + parseFloat(value).toFixed(2);
    } else {
      return parseFloat(0).toFixed(2);
    }
  },
  getGlobalOptionKey: function getGlobalOptionKey(key_name) {
    if (this.$store) {
      var global_array = this.$store.getters.getGlobalOptions;
      if (global_array.length > 0) {
        return global_array;
      }
    }
  },
  getMyCinemaStatusNew: function getMyCinemaStatusNew() {
    return this.secureStore.get("MYCINEMASTATUS");
  },

  goBack: function goBack(error) {
    this.$router.go(-1);
  },
  _CatchError: function _CatchError(error) {
    // console.log('errr::::', error)
    _vue2.default.toasted.show(error || "Sorry! Something went wrong. kindly contact your administrator");
  },
  _GoToSomethingWentWrong: function _GoToSomethingWentWrong() {
    this.$router.push({
      path: "/something-went-wrong"
    });
  },
  _GoToAccessDenied: function _GoToAccessDenied() {
    this.$router.push({
      path: "/access-denied"
    });
  },
  _GoToError404: function _GoToError404() {
    this.$router.push({
      path: "/404"
    });
  },
  _GoToRoute: function _GoToRoute(path) {
    this.$router.push({
      path: path
    });
  },

  GetViewUsersDetails: function GetViewUsersDetails(user_id) {
    var string = "";
    var promise = getFirstUserData(user_id).then(function (res) {
      string = res.status && res["Records"] && res.Records.length > 0 ? res.Records[0].user_name : "-";
    });
    // console.log('promise :', promise);
    // console.log('string :', string);
    // getFirstUserData(user_id).map(x => { console.log('x :', x); })
    return promise;
  },
  CreateFilterObject: function CreateFilterObject(array) {
    var obj = {};
    array.map(function (x) {
      obj[x.key] = "";
    });
    return obj;
  },
  GetMonthFirstDate: function GetMonthFirstDate() {
    var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, "01"].join("-");
  },
  GetCurrentDate: function GetCurrentDate() {
    var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  },
  formatDate: function formatDate(date) {
    var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  },
  _formatDate_dd_mm_yyyy: function _formatDate_dd_mm_yyyy(date) {
    var d = new Date(date);
    var formatted_date = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
    return formatted_date;
  },

  _GetImagePath: function _GetImagePath(imagePath) {
    if (imagePath && imagePath.length > 0) {
      var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      var regex = new RegExp(expression);

      if (imagePath.match(regex)) {
        return imagePath;
      }
      if (imagePath.match(/S3\//g)) {
        return "" + _constant2.default.imageS3BaseURL + imagePath;
      } else {
        return "" + _constant2.default.imageBaseURL + imagePath;
      }
    }
  },

  _downloadImagePath: function _downloadImagePath(imagePath, fileName) {
    var imageUrl = "" + _constant2.default.imageBaseURL + imagePath;
    _axios2.default.get(imageUrl, { responseType: "blob" }).then(function (response) {
      console.log(response.data);
      var blob = new Blob([response.data]);
      var link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    }).catch(console.error);
  },
  getCurrentDateNew: function getCurrentDateNew(format) {
    if (format) {
      return (0, _moment2.default)().format(format);
    } else {
      return (0, _moment2.default)().format("YYYY-MM-DD");
    }
  },
  getCurrentTime: function getCurrentTime() {
    return (0, _moment2.default)().format("HH:mm");
  },
  getCinemaId: function getCinemaId() {
    return localStorage.getItem("cinema_id") || null;
  },
  getUserDetail: function getUserDetail() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var user_info = localStorage.getItem("USER_INFO") || null;
    if (user_info) {
      user_info = JSON.parse(localStorage.getItem("USER_INFO"));
    }
    if (key) {
      return user_info[key];
    } else {
      return user_info;
    }
  },
  getUserShiftData: function getUserShiftData() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var user_info = localStorage.getItem("USER_SHIFT_DATA") || null;
    if (user_info) {
      user_info = JSON.parse(localStorage.getItem("USER_SHIFT_DATA"));
    }
    if (key) {
      return user_info[key];
    } else {
      return user_info;
    }
  },
  getSpecificGlobalOption: function getSpecificGlobalOption() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var globalOptions = this.globaloptionsArr;
    var globalOptionValue = "";
    if (globalOptions.length > 0 && key != null) {
      var findGlobalOption = globalOptions.find(function (globalOption) {
        return globalOption.go_key === key;
      });
      if (findGlobalOption && (0, _keys2.default)(findGlobalOption).length > 0) {
        globalOptionValue = findGlobalOption.go_value;
      } else {
        globalOptionValue = "";
      }
    }
    console.log({ globalOptionValue: globalOptionValue }, "from globalOtpionValue");
    return globalOptionValue;
  },
  getReportDates: function getReportDates(reportRoute) {
    var fromDate = window.localStorage.getItem("fromDate");
    var toDate = window.localStorage.getItem("toDate");
    var obj = {
      fromDate: (0, _moment2.default)().format("YYYY-MM-DD"),
      toDate: (0, _moment2.default)().format("YYYY-MM-DD"),
      reportRoute: window.localStorage.getItem("reportRoute")
    };
    if (reportRoute == obj.reportRoute && fromDate && toDate) {
      obj["fromDate"] = (0, _moment2.default)(fromDate).format("YYYY-MM-DD");
      obj["toDate"] = (0, _moment2.default)(toDate).format("YYYY-MM-DD");
    }
    return obj;
  },
  setReportDates: function setReportDates(obj) {
    var objectKeys = (0, _keys2.default)(obj);
    if (objectKeys.length) {
      objectKeys.forEach(function (key) {
        window.localStorage.setItem(key, obj[key]);
      });
    }
    return true;
  },


  getLangSpecificAttribute: _Languages.getLangSpecificAttribute
  // getLangSpecificContent,
};

var beforeDestroy = function beforeDestroy() {};

var storeService = {
  data: function data() {
    return _data();
  },
  computed: computed,
  beforeMount: beforeMount,
  methods: methods,
  beforeDestroy: beforeDestroy
};

exports.default = storeService;

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__(106);

exports.default = {
    imageBaseURL: _index.BASEURL,
    imageS3BaseURL: !!_index.IMGBASEURL ? _index.IMGBASEURL : "https://img-dev.brij.tech/",

    movieImages: {
        moviesUploadThumbnailImage: "280*350"
    },
    dateFormat: "dd MMM yyyy",
    cookiekeys: {
        BRHSID: 'BRHSID'
    }
};

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getNumberFormatter = exports.getNumberFormatter = function getNumberFormatter(format, precesion) {
  return function (number) {
    if (number) {
      return number.toLocaleString(format, {
        minimumFractionDigits: precesion != "undefined" ? precesion : 2,
        maximumFractionDigits: precesion != "undefined" ? precesion : 2
      });
    } else {
      return "0";
    }
  };
};

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLangSpecificAttribute = getLangSpecificAttribute;
exports.default = [{ flag: "us", language: "en", title: "English" }, { flag: "es", language: "es", title: "Español" }];
function getLangSpecificAttribute(languageSpecificImages, target_lang_id, attr) {
  if (!languageSpecificImages || languageSpecificImages.length === 0) return null;

  var target_obj = languageSpecificImages.find(function (x) {
    return x.content_lang_id === target_lang_id;
  });

  if (target_obj && target_obj[attr]) {
    return target_obj[attr];
  } else {
    // check english
    var eng_obj = getLangSpecificObject(languageSpecificImages, "english");
    if (eng_obj && eng_obj[attr]) {
      return eng_obj[attr];
    }

    // check german
    var german_obj = getLangSpecificObject(languageSpecificImages, "german");
    if (german_obj && german_obj[attr]) {
      return german_obj[attr];
    }

    // french
    // check german
    var french_obj = getLangSpecificObject(languageSpecificImages, "french");
    if (french_obj && french_obj[attr]) {
      return french_obj[attr];
    }

    // italian
    // check german
    var italian_obj = getLangSpecificObject(languageSpecificImages, "italian");
    if (italian_obj && italian_obj[attr]) {
      return italian_obj[attr];
    }
  }

  if (languageSpecificImages.length > 0) {
    return languageSpecificImages[0][attr];
  }

  return null;
}

function getLangSpecificObject(arr) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  if (arr && arr.length > 0) {
    var obj = arr.find(function (x) {
      return x.lang_name && x.lang_name.toLowerCase() === language.toLowerCase();
    });

    if (obj) return obj;else return null;
  } else {
    return null;
  }
}

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticationService = undefined;

var _axios = __webpack_require__(105);

var _axios2 = _interopRequireDefault(_axios);

var _lodash = __webpack_require__(254);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var secretKey = "HereIsTheMySecretKey_LOL";

var authenticationService = exports.authenticationService = {
  login: login,
  logout: logout
  // currentUser: currentUserSubject.asObservable(),
  // get currentUserValue() {
  //   return currentUserSubject.value;
  // },
};
// function set(key, value) {
//   if (key && value && String(key).length > 0 && String(value).length > 0) {
//     let setEncryptedData = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
//     window.localStorage.setItem(key, setEncryptedData);
//   } else {
//     console.error('key value is undefined');
//   }
// }

// function get(key) {
//   let getEncryptedData = window.localStorage.getItem(key);
//   if (!_.isNull(getEncryptedData))
//     return JSON.parse(CryptoJS.AES.decrypt(getEncryptedData, secretKey).toString(CryptoJS.enc.Utf8))
//   return null;
// }

function login(username, password) {
  // Call API
  // return Axios;
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("USINFO");
  // currentUserSubject.next(null);
}

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Api = __webpack_require__(253);

var _Api2 = _interopRequireDefault(_Api);

var _axios = __webpack_require__(105);

var _axios2 = _interopRequireDefault(_axios);

var _jquery = __webpack_require__(934);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  SendLog: function SendLog(payload) {
    return (0, _Api2.default)().post("/api/v3/external/sales-analytics/insert-log", payload);
  },
  GetIpDetails: function GetIpDetails() {
    _jquery2.default.ajax({
      url: "https://ipapi.co/json",
      method: "GET"
    }).then(function (ressss) {
      console.log("objectobjectobjectobjectobjectobject :");
    });
  },
  SendNotificationLog: function SendNotificationLog(payload) {
    return (0, _Api2.default)().post("/api/v3/external/sales-analytics/notification-log", payload);
  },
  GetAllNotification: function GetAllNotification(payload) {
    return (0, _Api2.default)().get("/api/v3/external/sales-analytics/get-notification-log?user_id=" + payload.user_id + "&limit=" + payload.limit + "&currentPage=" + payload.currentPage);
  },
  UpdateNotificationStatus: function UpdateNotificationStatus(payload) {
    return (0, _Api2.default)().put("/api/v3/external/sales-analytics/update-notification-log", payload);
  }
};
// https://api.ipapi.com/check?access_key=229c548dcafb9cff13041d9544ac60af

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 936:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 937:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 938:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 939:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 940:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 941:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 942:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 945:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[618]);


// WEBPACK FOOTER //
// static/js/app.ff4099376dc44ba6a3e6.js